<template>
  <!--begin::Stats Widget 7-->
  <div class="card card-custom card-stretch card-stretch-half gutter-b">
    <!--begin::Body-->
    <div class="card-body d-flex flex-column p-0">
      <div
        class="d-flex align-items-center justify-content-between card-spacer flex-grow-1"
      >
        <div class="d-flex flex-column mr-2">
          <a
            href="#"
            class="text-dark-75 text-hover-primary font-weight-bolder font-size-h5"
          >
            Cantidad de Pagos
          </a>
          <span class="text-muted font-weight-bold mt-2">
            últimos 7 días
          </span>
        </div>
        <span class="symbol symbol-light-success symbol-45">
          <span class="symbol-label font-weight-bolder">
            {{data_series.cantidad}}
          </span>
        </span>
      </div>
      <!--begin::Chart-->
      <apexchart
        class="card-rounded-bottom"
        :options="chartOptions"
        :series="series"
        type="area"
      ></apexchart>
      <!--end::Chart-->
    </div>
    <!--end::Body-->
  </div>
  <!--end::Stats Widget 7-->
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "widget-7",
  props: ['data_series'],
  data() {
    console.log('data data '+ JSON.stringify(this.data_series));
    //Update chart
    return {
      chartOptions: {xaxis:{categories: [""]}},
      series: [
        {
          name: "Suscripciones",
          data: [0]
        }
      ]
    };
  },
  computed: {
    ...mapGetters(["layoutConfig"])
  },
  methods: {
    updateSeries() {
      const newData = this.series.data=this.data_series.valores;
      //const colors = ['#008FFB', '#00E396', '#FEB019', '#FF4560', '#775DD0']
      // Make sure to update the whole options config and not just a single property to allow the Vue watch catch the change.
      this.chartOptions = {
        xaxis: {categories: this.data_series.categorias}
      };
      // In the same way, update the series option
      this.series = [{
        data: newData
      }]      
    }
  },
  watch: {
    data_series: function() {
      console.log('data actualizada');
      this.updateSeries();
      //   this.series[0].data[0] = _channel1;
    }
  },
  mounted() {
    // reference; kt_stats_widget_7_chart
    console.log('data mounted'+ JSON.stringify(this.data_series.categorias));
    this.chartOptions = {
      chart: {
        type: "area",
        height: 150,
        toolbar: {
          show: false
        },
        zoom: {
          enabled: false
        },
        sparkline: {
          enabled: true
        }
      },
      plotOptions: {},
      legend: {
        show: false
      },
      dataLabels: {
        enabled: false
      },
      fill: {
        type: "solid", 
        opacity: 1
      },
      stroke: {
        curve: "smooth",
        show: true,
        width: 3,
        colors: [this.layoutConfig("colors.theme.base.success")]
      },
      xaxis: {
        categories: [""],//this.data_series.categorias,
        axisBorder: {
          show: false
        },
        axisTicks: {
          show: false
        },
        labels: {
          show: false,
          style: {
            colors: this.layoutConfig("colors.gray.gray-500"),
            fontSize: "12px",
            fontFamily: this.layoutConfig("font-family")
          }
        },
        crosshairs: {
          show: false,
          position: "front",
          stroke: {
            color: this.layoutConfig("colors.gray.gray-300"),
            width: 1,
            dashArray: 3
          }
        },
        tooltip: {
          enabled: true,
          formatter: undefined,
          offsetY: 0,
          style: {
            fontSize: "12px",
            fontFamily: this.layoutConfig("font-family")
          }
        }
      },
      yaxis: {
        labels: {
          show: false,
          style: {
            colors: this.layoutConfig("colors.gray.gray-500"),
            fontSize: "12px",
            fontFamily: this.layoutConfig("font-family")
          }
        }
      },
      states: {
        normal: {
          filter: {
            type: "none",
            value: 0
          }
        },
        hover: {
          filter: {
            type: "none",
            value: 0
          }
        },
        active: {
          allowMultipleDataPointsSelection: false,
          filter: {
            type: "none",
            value: 0
          }
        }
      },
      tooltip: {
        style: {
          fontSize: "12px",
          fontFamily: this.layoutConfig("font-family")
        },
        y: {
          formatter: function(val) {
            return val + " pagos recibidos";
          }
        }
      },
      colors: [this.layoutConfig("colors.theme.light.success")],
      markers: {
        colors: [this.layoutConfig("colors.theme.light.success")],
        strokeColor: [this.layoutConfig("colors.theme.base.success")],
        strokeWidth: 3
      },
      grid: {
        show: false,
        padding: {
          left: 0,
          right: 0
        }
      }
    };
  }
};
</script>